import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './OrganizationAreasView.css';

import { apiUrl } from '../../../utility/Connections';

import { Layout, Divider } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import TableAreas from '../../../components/tableAreas/tableAreas';
import FormAreas from '../../../components/formAreas/formAreas';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import Search from '../../../components/search/search';
const { Content } = Layout;

const OrganizationAreasView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [filteredDataAreas, setFilteredDataAreas] = useState([]);
    const [dataAreas, setDataAreas] = useState([]);
    const [orgId, setOrgId] = useState("");
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getAreas(current_org.org_id);
        }
    }, []);

    const getAreas = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando áreas de la organización...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/areas/get-areas/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataAreas(data);
                setShowLoading(false);
                if (searchText) {
                    filterData(searchText, data)
                } else {
                    setFilteredDataAreas(data);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para agregar un nuevo registro de area
    const addArea = (newArea) => {
        setShowLoading(true);
        setLoadingText("Agregando área...")

        const formData = new FormData();
        formData.append("area_org_id", orgId);
        formData.append("area_area", newArea);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.post(`${apiUrl}/areas/create-area/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getAreas(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para editar el nombre de una area
    const handleInputChangeTable = (area_id, area) => {
        setShowLoading(true);
        setLoadingText("Guardando área...")

        const formData = new FormData();
        formData.append("area_id", area_id);
        formData.append("area_area", area);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/areas/update-area/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getAreas(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    // Función para eliminar un registro de area
    const handleDeleteTable = (area_id) => {
        setShowLoading(true);
        setLoadingText("Eliminando área...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.delete(`${apiUrl}/areas/delete-area/${area_id}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getAreas(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const onSearch = (value) => {
        setSearchText(value)
        filterData(value, dataAreas)
    }

    const filterData = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataAreas(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.area_area.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataAreas(filtered);
        }
    }

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            <div className='layout-content'>
                <FormAreas addArea={addArea} />
            </div>
            <Divider />
            <div className='layout-content'>
                <Search onSearch={onSearch} />
                <br></br>
                <TableAreas data={filteredDataAreas} handleInputChange={handleInputChangeTable} handleDelete={handleDeleteTable} />
            </div>
        </Content>
    </div>
}

export default OrganizationAreasView;